import HomePage from './pages/HomePage';
import AdminApp from './pages/AdminApp';
import CachePage from './pages/CachePage';
import SettingsPage from './pages/SettingsPage';
import { getUserRole } from './utils/tokenUtils';
import { useDowntime } from './hooks/useDowntime';
import { useTenantBranding } from './hooks/useTenantBranding';
import { ADMIN_APP_TYPES } from './consts/shared';
import CronServerPage from './pages/CronServerPage';
import ProtectedRoute from './routes/ProtectedRoutes';
import DowntimeScreen from './components/DowntimeScreen';
import GenericMessagePage from './pages/GenericMessagePage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  useTenantBranding();
  const { isDowntimeActive, startUtc, endUtc, startLabel, endLabel } = useDowntime();

  if (isDowntimeActive) {
    return <DowntimeScreen start={startUtc} end={endUtc} startLabel={startLabel} endLabel={endLabel} />;
  }

  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={
            <ProtectedRoute 
              children={[<HomePage key="home-page" />]} 
              allowedRoles={["ROLE_SUPER_ADMIN"]}
              isHomePage={true}
            />
          } 
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute 
              children={[
                <AdminApp key={ADMIN_APP_TYPES.ADMIN} adminType={ADMIN_APP_TYPES.ADMIN} />,
                <AdminApp key={ADMIN_APP_TYPES.MANAGER} adminType={ADMIN_APP_TYPES.MANAGER} />,
              ]} 
              allowedRoles={["ROLE_COMPANY_ADMIN", "ROLE_MANAGER_DASHBOARD_VIEWER"]}
            />
          }
        />
        <Route
          path="/stats"
          element={<CachePage key="stats-page" />}
        />
        <Route
          path="/cron-server"
          element={getUserRole() === "ROLE_SUPER_ADMIN" ? <CronServerPage key="cron-server-page" /> : <GenericMessagePage message="You are not authorized to access this page" />}
        />
        <Route
          path="/settings"
          element={getUserRole() === "ROLE_SUPER_ADMIN" ? <SettingsPage key="settings-page" /> : <GenericMessagePage message="You are not authorized to access this page" />}
        />
        <Route path="*" element={<GenericMessagePage message="404 - Page Not Found" />} />
      </Routes>
    </Router>
  );
}

export default App;
